import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialInstitutionItemState: Dtos.InstitutionItem & IRegistrationFormState = {
    id: null,
    institutionId: null,
    institution: null,
    institutionItemTemplateId: null,
    institutionItemTemplate: null,
    collectionInstanceId: null,
    collectionInstance: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
    search: "",
    dataEntered: null,
    filesAdded: null,
    version: null
}

export interface IInstitutionItemReduxFormState {
    id: IFieldState<number>,
    institutionId: IFieldState<number>,
    institutionItemTemplateId: IFieldState<number>,
    collectionInstanceId: IFieldState<number>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    message: IFieldState<string>,
    openedModals: IFieldState<string[]>,
    version: IFieldState<string>
}
